/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S6_P1Inputs */

const en_guide_json_rest_api_s6_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A REST response is a contract. Once clients depend on a field, removing or renaming it becomes a breaking change, so a little thought early saves a lot of migration later. Prefer clear, stable key names over clever abbreviations, and keep the same casing across every endpoint so consumers are not left guessing.`)
};

const ko_guide_json_rest_api_s6_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST 응답은 하나의 계약입니다. 클라이언트가 어떤 필드에 의존하기 시작하면 그것을 제거하거나 이름을 바꾸는 일이 호환성을 깨는 변경이 되므로, 초기에 조금만 고민하면 나중의 많은 마이그레이션을 아낄 수 있습니다. 영리한 축약보다 명확하고 안정적인 키 이름을 택하고, 모든 엔드포인트에서 같은 대소문자 규칙을 유지해 사용자가 헤매지 않게 하세요.`)
};

const ja_guide_json_rest_api_s6_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST レスポンスは一つの契約です。クライアントがあるフィールドに依存し始めると、それを削除したり名前を変えたりすることが互換性を壊す変更になります。だから早い段階で少し考えておくと、あとの多くの移行を節約できます。賢い省略形より明確で安定したキー名を選び、すべてのエンドポイントで同じ大文字小文字の規則を保ち、利用者が推測せずに済むようにしましょう。`)
};

/**
* | output |
* | --- |
* | "A REST response is a contract. Once clients depend on a field, removing or renaming it becomes a breaking change, so a little thought early saves a lot of mi..." |
*
* @param {Guide_Json_Rest_Api_S6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s6_p1 = /** @type {((inputs?: Guide_Json_Rest_Api_S6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s6_p1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s6_p1(inputs)
	return ja_guide_json_rest_api_s6_p1(inputs)
});